<template>
    <div>
        <v-menu v-if="companyFullName" right :options="options" @click="handleClick">
            <v-link size="subheadling">{{ companyFullName }}</v-link>
            <v-text type="caption" v-margin.xs.left="1" v-margin.right="1">
                ID: {{ companyId }}
            </v-text>
            <v-font-icon>
                arrow_drop_down
            </v-font-icon>
        </v-menu>
        <v-spinner v-else />
    </div>
</template>
<script>
export default {
    name: 'company-menu',
    props: {
        onLogout: Function,
        companyFullName: String,
        companyId: [String, Number],
    },
    data() {
        return {
            options: [
                'Профиль компании',
                'Изменение пароля',
                'Выйти',
            ]
        }
    },
    methods: {
        handleClick(item) {
            switch (item) {
                case 'Профиль компании':
                    this.$router.push({ name: 'profile' });
                    break;
                case 'Изменение пароля':
                    this.$router.push({ name: 'changePassword' });
                    break;
                case 'Выйти':
                    this.onLogout()
                        .then(() => {
                            this.$router.push({ name: 'login' });
                        });
                    break;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// CompanyMenu.vue?6e5dab84